import { CONTENT_BACKGROUND_COLOR } from '@app/core/cms-flex/types';

import { ContentColor } from '../types';

export const CONTENT_COLOR = new Map<CONTENT_BACKGROUND_COLOR, ContentColor>()
  .set(CONTENT_BACKGROUND_COLOR.TRANSPARENT, 'content-background__transparent')
  .set(CONTENT_BACKGROUND_COLOR.WHITE, 'content-background__white')
  .set(CONTENT_BACKGROUND_COLOR.ORANGE, 'content-background__orange');
